import asifAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/asif.avif';
import asif from '../../../../../../client/assets_seller/about_us/avatar/2025/asif.jpg';
import asifWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/asif.webp';
import harryAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/harry.avif';
import harry from '../../../../../../client/assets_seller/about_us/avatar/2025/harry.jpg';
import harryWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/harry.webp';
import jameswilsonAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/james.avif';
import jameswilson from '../../../../../../client/assets_seller/about_us/avatar/2025/james.jpg';
import jameswilsonWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/james.webp';
import lizAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/liz.avif';
import liz from '../../../../../../client/assets_seller/about_us/avatar/2025/liz.jpg';
import lizWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/liz.webp';
import naomiAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/naomi.avif';
import naomi from '../../../../../../client/assets_seller/about_us/avatar/2025/naomi.jpg';
import naomiWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/naomi.webp';
import nicAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/nic.avif';
import nic from '../../../../../../client/assets_seller/about_us/avatar/2025/nic.jpg';
import nicWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/nic.webp';
import tanyaAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/tanya.avif';
import tanya from '../../../../../../client/assets_seller/about_us/avatar/2025/tanya.jpg';
import tanyaWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/tanya.webp';
import tomAvif from '../../../../../../client/assets_seller/about_us/avatar/2025/tom.avif';
import tom from '../../../../../../client/assets_seller/about_us/avatar/2025/tom.jpg';
import tomWebp from '../../../../../../client/assets_seller/about_us/avatar/2025/tom.webp';
import nehalAvif from '../../../../../../client/assets_seller/about_us/avatar/2026/nehal.avif';
import nehal from '../../../../../../client/assets_seller/about_us/avatar/2026/nehal.png';
import nehalWebp from '../../../../../../client/assets_seller/about_us/avatar/2026/nehal.webp';

const teamList = [
  {
    avif: tomAvif,
    img: tom,
    name: 'Tom Leathes',
    title: 'CEO & Founder',
    webp: tomWebp,
  },
  {
    avif: harryAvif,
    img: harry,
    name: 'Harry Jones',
    title: 'Co-Founder',
    webp: harryWebp,
  },
  {
    avif: lizAvif,
    img: liz,
    name: 'Liz Kistruck',
    title: 'Chief Financial Officer',
    webp: lizWebp,
  },
  {
    avif: jameswilsonAvif,
    img: jameswilson,
    name: 'James Wilson',
    title: 'Chief Operating Officer',
    webp: jameswilsonWebp,
  },
  {
    avif: naomiAvif,
    img: naomi,
    name: 'Naomi Walkland',
    title: 'Chief Marketing Officer',
    webp: naomiWebp,
  },
  {
    avif: tanyaAvif,
    img: tanya,
    name: 'Tanya Cordrey',
    title: 'Chief Product Officer',
    webp: tanyaWebp,
  },
  {
    avif: asifAvif,
    img: asif,
    name: 'Asif Ghulamali',
    title: 'VP of Finance',
    webp: asifWebp,
  },
  {
    avif: nehalAvif,
    img: nehal,
    name: 'Nehal Bhayani',
    title: 'Chief People Officer',
    webp: nehalWebp,
  },
  {
    avif: nicAvif,
    img: nic,
    name: 'Nic Hartley',
    title: 'VP of Seller Services',
    webp: nicWebp,
  },
];

export default teamList;
